export default __webpack_public_path__ + "static/media/BestSellingDesktop.4708a8a4.png";